<div class="loading-wrapper">
  <div class="loading">
    <ng-lottie [options]="options" width="200px" height="200px"></ng-lottie>
  </div>
</div>
